export default __webpack_public_path__ + "static/media/css3.b19a087e.png";